import React from 'react'

import { Typography, Tag } from 'antd'

const { Text } = Typography

const SubmissionTimeTag = (props) => {
  const { code, message } = props?.status

  return (
    <>
      {code === 'late' && <Tag color="red">Late</Tag>}
      {code === 'onTime' && <Tag color="green">On Time</Tag>}
    </>
  )
}

export default SubmissionTimeTag
